<template>
  <transition name="fade">
    <span id="backToTop" class="badge badge-secondary" title="Go to top" @click="scrollToTop()">Back to top <i class="fa fa-chevron-circle-up d-inline"></i></span>
  </transition>
</template>

<script>
export default {
  name: "vue-ez-scroll-to-top",
  created() {
    let vm = this;
    window.onscroll = function() {
      vm.scrollFunction();
    };
  },
  methods: {
    scrollFunction() {
      if (
        document.body.scrollTop > 100 ||
        document.documentElement.scrollTop > 100
      ) {
        document.getElementById("backToTop").style.display = "block";
      } else {
        document.getElementById("backToTop").style.display = "none";
      }
    },
    scrollToTop() {
      window.scroll({
        top: 0,
        left: 0,
        behavior: "smooth"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/_global";

.fade-enter-active {
  transition: opacity 3s;
}
.fade-leave-active {
  opacity: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

#backToTop {
  opacity: 0.8;
  display: none;
  position: fixed;
  bottom: 1em;
  left: 1em;
  z-index: 99;
  cursor: pointer;
  border-radius: 0;
}
</style>
